import TEALIUM from "../../../../enums/tealium-enums";
import { track } from "../../../../util/tealium";

export const profileOverviewTabErrorTrack = () => {
  track(TEALIUM.U_TAG_METHOD.VIEW, "", "", TEALIUM.CATEGORY.GLOBAL_CML, "profile_overview_tab_error", "");
};
